"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Teams API
 * # Summary  This API is for managing teams and their members.  Teams can be used as a sharing target for specific assets, and can have asset ownership transferred to them.  The teams feature is turned on by either the `strict_permissions` or `enable_teams` feature flags. If both of those feature flags are off, this API will always return a 404.  On any domain, teams can be managed in the UI by going to `/admin/teams`.  # Team Roles  Within a team, a user has a \"team role\".  This team role will either be `owner` or `member`.  Team members with the `owner` role can add/remove other team members, and promote other team members to the `owner` role. There can be multiple members with the `owner` role on a team.  At least one member *must* have the `owner` role, and the API will prevent demoting or removing the final `owner` from a team.  Members with the `member` and the `owner` team roles will both get permissions for any assets that are shared to or owner by the team.  # Changelog  ## 1.1.1  Add missing `title` of `TeamEligibleForDeletionResponse` to [`eligibleForDeletion`](#operation/eligibleForDeletion) operation.  ## 1.1.0  Add [`eligibleForDeletion`](#operation/eligibleForDeletion) operation.  ## 1.0.5  Documentation updates.  ## 1.0.4  Add `email` to `CreateOrUpdateTeamRequestParameters`.  ## 1.0.3  Return `204` (No Content) when deleting team members.  ## 1.0.2  Remove support for ES6 in `typescript-fetch` clients. This was breaking in Internet Explorer 11.  ## 1.0.1  Add missing `description` field to `Team` schema  ## 1.0.0  Initial specification.
 *
 * The version of the OpenAPI document: 1.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamRoleToJSON = exports.TeamRoleFromJSONTyped = exports.TeamRoleFromJSON = exports.TeamRole = void 0;
/**
 * The role that a user has on a team that lets them take different actions on the team.
 *
 * Team members with the `owner` role are able to add and remove other users.
 * @export
 * @enum {string}
 */
var TeamRole;
(function (TeamRole) {
    TeamRole["Owner"] = "owner";
    TeamRole["Member"] = "member";
})(TeamRole = exports.TeamRole || (exports.TeamRole = {}));
function TeamRoleFromJSON(json) {
    return TeamRoleFromJSONTyped(json, false);
}
exports.TeamRoleFromJSON = TeamRoleFromJSON;
function TeamRoleFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.TeamRoleFromJSONTyped = TeamRoleFromJSONTyped;
function TeamRoleToJSON(value) {
    return value;
}
exports.TeamRoleToJSON = TeamRoleToJSON;
